import React from 'react'

import styles from './base-form.module.css'
import Icon from '../icon'

export default ({ children, title, onBack = undefined }) => {
    return (
        <div>
            <div className={styles.menuHeader}>
                {!!onBack && (
                    <div onClick={onBack} className={styles.backControl}>
                        <Icon type="left_arrow"/>
                    </div>
                )}
                <div className={styles.menuHeaderTitle}>{title}</div>
            </div>
            <div className={styles.menuBody}>
                {children}
            </div>
        </div>
    )
}